import { createStyles } from 'antd-style'

export const useStyles = createStyles(
  (
    { token },
    props: {
      isCommentOwner?: boolean | null
    }
  ) => {
    const leftBottomRadius = props?.isCommentOwner ? '12px' : '0px'
    const rightBottomRadius = props?.isCommentOwner ? '0' : '12px'

    return {
      commentItem: {
        '& .ant-card-body': {
          padding: token.padding
        },

        borderRadius: `12px 12px ${rightBottomRadius} ${leftBottomRadius}`,
        backgroundColor: props?.isCommentOwner
          ? token.blue1
          : token.colorBgLayout
      }
    }
  }
)
